import React from 'react';

import InputText from '../../../shared/components/inputs/text/InputText';
// import Avatar from '../../../shared/components/avatar/Avatar';

const inputs = {
  name: {
    name: 'name',
    placeholder: 'Nome do usuário',
    rules: [{ required: true, message: 'Nome é obrigatório!' }],
  },
  password: {
    name: 'password',
    placeholder: 'Criar senha',
    rules: [{ required: true, message: 'Senha é obrigatória!' }],
  },
  email: {
    name: 'email',
    placeholder: 'email@email.com',
    rules: [
      {
        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
        message: 'Por favor insira um e-mail válido',
      },
    ],
  },
  phone: {
    name: 'phone',
    placeholder: '+55 00 0 0000-0000',
    rules: [{ required: true, message: 'Telefone é obrigatório!' }],
  },
};

class DadosPessoais extends React.Component {
  componentDidMount = () => this.props.form.validateFields();

  // clearState = () => this.setState({ imageUrl: '' });

  // onFinishUpload = (image) => this.setState({ imageUrl: image });

  render() {
    const { form, user } = this.props;
    return (
      <div className='uf__personal-fields'>
        {/* <div className='uf__avatar-col'>
          <Avatar
            onFinishUpload={this.onFinishUpload}
            imageUrl={this.state.imageUrl || user.photoUrl}
            form={form}
            name='photo'
          />
        </div> */}

        <div className='uf__fields-col'>
          <div className='uf__field'>
            <label className='uf__field-label'>Nome</label>
            <InputText
              initialValue={user.name}
              form={form}
              name={inputs.name.name}
              placeholder={inputs.name.placeholder}
              rules={inputs.name.rules}
            />
          </div>

          <div className='uf__fields-row'>
            <div className='uf__field'>
              <label className='uf__field-label'>E-mail</label>
              <InputText
                initialValue={user.email}
                form={form}
                name={inputs.email.name}
                placeholder={inputs.email.placeholder}
                rules={inputs.email.rules}
              />
            </div>
            <div className='uf__field'>
              <label className='uf__field-label'>Telefone</label>
              <InputText
                initialValue={user.phone}
                form={form}
                name={inputs.phone.name}
                mask='(##) #####-####'
                placeholder={inputs.phone.placeholder}
                rules={inputs.phone.rules}
              />
            </div>
          </div>

          <div className='uf__field uf__field--half'>
            <label className='uf__field-label'>Senha de acesso</label>
            <InputText
              type='password'
              autoComplete='new-password'
              initialValue={user.password}
              form={form}
              name={inputs.password.name}
              placeholder={inputs.password.placeholder}
              rules={user.id ? [] : inputs.password.rules}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DadosPessoais;
